export const events = {
    event: {
        SIGN_IN: 'sign_in',
        GET_STARTED: "get_started_submit",
        RESEARCH_ARTICLE_DOWNLOAD: "research_article_download",
        CREATE_FREE_ACCOUNT: "create_free_account",
        SEARCH_LOANS: "search_loans",
        SEARCH_DEALS: "search_deals",
        VIEW_RESEARCH: "view_research",
        VIEW_NEWSFLASH: "view_newsflash",
    },
    category: {
        SIGN_IN: 'Sign In',
        GET_STARTED: "Get Started",
        RESEARCH_ARTICLE_DOWNLOAD: "Research Article Download",
        CREATE_FREE_ACCOUNT: "Create Free Account",
        SEARCH_LOANS: "Search Loans",
        SEARCH_DEALS: "Search Deals",
        VIEW_RESEARCH: "View Research",
        VIEW_NEWSFLASH: "View Newsflash",
    },
    action: {
        CLICK: 'click'
    },
    label: {
        SIGN_IN: 'Sign In',
        GET_STARTED: "Get Started",
        RESEARCH_ARTICLE_DOWNLOAD: "Research Article Download",
        CREATE_FREE_ACCOUNT: "Create Free Account",
        SEARCH_LOANS: "Search Loans",
        SEARCH_DEALS: "Search Deals",
        VIEW_RESEARCH: "View Research",
        VIEW_NEWSFLASH: "View Newsflash",
    }
}